  <nav>
    <ul class="nav nav-tabs w-100"  role="tablist">
      <li class="nav-item" role="tab">
        <a
          class="nav-link"
          [routerLink]="['/home']"
        ><span class="fas fa-home"></span></a>
      </li>
      <li class="nav-item" role="tab">
        <a
          [routerLink]="linkRoughcheck"
          [class]="page === 'roughcheck' ? 'nav-link active' : 'nav-link'"
          i18n="Roughcheck"
        >MENU_ROUGHCHECK</a>
      </li>
      <li class="nav-item" role="tab">
        <a
          [routerLink]="linkAssessment"
          [class]="page === 'info' ? 'nav-link active' : 'nav-link'"
          [class.disabled]="rref ? null : true"
          i18n="Info">MENU_ASSESSMENT_INFO</a>
      </li>
      <li>
        <a
          [routerLink]="linkSections"
          [class]="page === 'assessment' ? 'nav-link active' : 'nav-link'"
          [class.disabled]="isAref(aref)"
          i18n="Assessment">MENU_ASSESSMENT</a>
      </li>
      <li class="nav-item" role="tab">
        <a
          [routerLink]="linkReport"
          [class]="page === 'report' ? 'nav-link active' : 'nav-link'"
          [class.disabled]="isAref(aref)"
          i18n="Report">MENU_REPORT</a>
      </li>
      <li class="nav-item" role="tab">
        <a
          [routerLink]="linkAction"
          [class]="page === 'action' ? 'nav-link active' : 'nav-link'"
          [class.disabled]="isAref(aref)"
          i18n="Action">MENU_ACTION</a>
      </li>
      <li class="nav-item" role="tab">
        <a
          [routerLink]="linkHelp"
          [class]="page === 'help' ? 'nav-link active' : 'nav-link'"
          i18n="Help"
          >MENU_HELP</a>
      </li>
    </ul>
  </nav>

